import React, { Component } from 'react';
import { RaisedButton, FlatButton, Dialog } from 'material-ui';
import LogIn from './integration-tourplan-login';

class TourPlanAuth extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
    };
  }

  componentWillMount() {
    const { integration, getAuth } = this.props;
    if (!integration.auth) getAuth();
  }

   _dialogHide = () => {
     this.setState({ dialogOpen: false });
   };

   _dialogShow = () => {
     this.setState({ dialogOpen: true });
   };

  render() {
    const dialogActions = [
      <FlatButton
        label="Dismiss"
        secondary
        disableTouchRipple
        onClick={this._dialogHide}
      />,
    ];
    const dialog = (
      <Dialog
        ref="dialog"
        actions={dialogActions}
        open={this.state.dialogOpen}
        modal
      >
        <LogIn {...this.props} transition={this._dialogHide} type="update"/>
      </Dialog>
      );


    return (
      <div style={{
        margin: 'auto',
        width: '70%',
        textAlign: 'center',
      }}
      >
          <div style={{ marginBottom: '20px', fontSize: '18px' }}>
          {"Your account have been authenticated."}
          </div>
          <div style={{ marginBottom: '20px' }}>
          {"Should you wish to update your credentials, please click button below."}
          </div>
          <RaisedButton
            label="UPDATE CREDENTIALS"
            onTouchTap={() => this._dialogShow()}
            secondary
          />
          {dialog}
      </div>
    );
  }
}

export default TourPlanAuth;



// WEBPACK FOOTER //
// ./src/app/components/integration/integration-tourplan-auth.jsx